module.exports = __webpack_public_path__ + "static/media/good-review2.b67f3583.png";